/** jest ignore */

import React from 'react';
import { useForm } from 'react-hook-form';
import { Controls, validators } from 'shared/helper/form';
import AsyncFormSubmission from './AsyncFormSubmission';
var Form = Controls.Form,
  Text = Controls.Text;
var isEmail = validators.isEmail;
var defaultValues = {
  email: ''
};
var ForgotPasswordForm = function ForgotPasswordForm(_ref) {
  var processing = _ref.processing,
    requestPasswordReset = _ref.requestPasswordReset;
  var methods = useForm({
    defaultValues: defaultValues,
    shouldFocusError: false
  });
  return /*#__PURE__*/React.createElement(Form, {
    methods: methods,
    className: "login-form clearfix",
    onSubmit: requestPasswordReset
  }, /*#__PURE__*/React.createElement(Text, {
    label: "Email address",
    messages: {
      isEmail: 'emailAddressInvalidFormat'
    },
    name: "email",
    validators: {
      isEmail: isEmail
    },
    styles: {
      wrapper: 'mb-3'
    }
  }), /*#__PURE__*/React.createElement(AsyncFormSubmission, {
    processing: processing,
    label: "Request password reset"
  }));
};
export default ForgotPasswordForm;